import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ILearnActionRepository } from '../../repositories/interfaces/iLearnActionRepository';
import { ILearnActionResponse, ISearchClickActionPayload } from '../../../entity/interface/iLearnAction';

export interface ISearchClickActionUseCase {
    execute(apiKey: string, paylod: ISearchClickActionPayload, identityToken: string): Promise<ILearnActionResponse>;
}

export class SearchClickActionUseCase implements ISearchClickActionUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get searchClickActionRepository(): ILearnActionRepository {
        return container.resolve<ILearnActionRepository>(DI.REPOSITORIES.ILearnActionRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, paylod: ISearchClickActionPayload, identityToken: string): Promise<any> {
        return this.searchClickActionRepository.searchClickAction(apiKey, paylod, identityToken);
    }
}
